export const CARD_VARIANTS = {
  enter: { opacity: 0, y: 40, scale: 0.97 },
  center: { opacity: 1, y: 0, scale: 1 },
  exit: { opacity: 0, y: -40, scale: 0.95 },
};

export const TOSS_VARIANTS = {
  enter: { opacity: 0, y: 40, scale: 0.97 },
  center: { opacity: 1, y: 0, scale: 1 },
  exit: {
    opacity: 0,
    x: -360,
    y: 60,
    rotate: -18,
    scale: 0.9,
    transition: { duration: 0.32, ease: [0.4, 0, 1, 1] },
  },
};
